import * as React from "react";

type ComponentEnhancer<I, O> = (component: React.ComponentType<I>) => React.ComponentType<O>;
export const compose = <I, O>(
    ...hocs: Array<ComponentEnhancer<any, any>>
): ComponentEnhancer<I, O> => (WrappedComponent) =>
        hocs.reduceRight((Component, hoc) => hoc(Component), WrappedComponent);
